import PasswordChangeViewContainer from "@pathwright/auth/src/views/auth/password/change/PasswordChangeViewContainer"
import PasswordCreateViewContainer from "@pathwright/auth/src/views/auth/password/create/PasswordCreateViewContainer"
import { ConnectedProvider as SpaceConnectedProvider } from "@pathwright/auth/src/views/space/api/context"

function PasswordChangeContainer({ hasPassword }: { hasPassword: true }) {
  return (
    <SpaceConnectedProvider>
      {hasPassword ? (
        <PasswordChangeViewContainer
          onContinue={() => window.App.navigate("/manage/profile/")}
        />
      ) : (
        <PasswordCreateViewContainer
          onContinue={() => window.App.navigate("/manage/profile/")}
        />
      )}
    </SpaceConnectedProvider>
  )
}

export default PasswordChangeContainer
